module.exports = __webpack_public_path__ + "static/ENmobSlide1-e3333dcd8bc4d4a6454f6b8e4c779e3d.jpg";